<template>
  <div class="project-filter">
    <v-layout justify-space-between>
      <v-radio-group
        :value="filter.date_type"
        @change="handleDateType"
        hide-details
        class="mr-8 mb-0 mt-3"
      >
        <v-radio
          value="created_at"
          hide-details
          class="mt-5"
          label="Date de CREATION"
        ></v-radio>

        <v-radio
          value="initial_transfer_at"
          hide-details
          class="mb-3"
          label="Date de TRANSFERT"
        ></v-radio>

        <v-checkbox
          :value="filter.unprocessed"
          @change="handleUnprocessed"
          hide-details
          label="Fiche non traitée"
        ></v-checkbox>
      </v-radio-group>

      <v-flex>
        <v-layout wrap justify-center>
          <v-flex sm6 mt-3 mb-5 mr-3>
            <v-dialog width="290px" v-model="datepickerDateFrom">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="filter.date_from | dateFormat"
                  label="Du"
                  append-icon="mdi-calendar"
                  v-on="on"
                  @input="handleDateFrom"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                :value="filter.date_from"
                @input="handleDateFrom"
                @change="datepickerDateFrom = false"
              ></v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex sm6 mt-3 mb-5>
            <v-dialog v-model="datepickerDateTo" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="filter.date_to | dateFormat"
                  label="Au"
                  append-icon="mdi-calendar"
                  v-on="on"
                  @input="handleDateTo"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                :value="filter.date_to"
                @input="handleDateTo"
                @change="datepickerDateTo = false"
              ></v-date-picker>
            </v-dialog>
          </v-flex>

          <v-flex sm6 mr-3>
            <v-layout class="mb-5">
              <v-select
                :value="filter.applicator"
                @change="handleApplicator"
                item-text="fullname"
                item-value="id"
                hide-details
                :items="applicatorsItems"
                label="Applicateur :"
                clearable
              ></v-select>
            </v-layout>
          </v-flex>
          <v-flex sm6>
            <v-layout>
              <v-text-field
                :value="filter.search"
                @input="handleSearch"
                label="Recherche patient"
              ></v-text-field>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- <div class="filter-container">
      <div class="filter-form-group">
        <label for="" class="block">Du</label>
        <input
          class="block w-full input-tw"
          type="date"
          :value="filter.date_from"
          @input="handleDateFrom"
        />
      </div>

      <div class="filter-form-group">
        <label class="block" for="">Au</label>
        <input
          class="w-full block input-tw"
          type="date"
          :value="filter.date_to"
          @input="handleDateTo"
        />
      </div>

      <div class="filter-form-group">
        <label class="block" for="">Applicateur ID</label>
        <input
          class="block w-full input-tw"
          type="text"
          :value="filter.applicator"
          @input="handleApplicator"
        />
      </div>

      <div class="filter-form-group">
        <label class="block" for="">Patient</label>
        <input
          class="block w-full input-tw"
          placeholder="Patient"
          type="text"
          :value="filter.search"
          @input="handleSearch"
        />
      </div>

      <label for="">Fiche non traitée</label>
      <input
        type="checkbox"
        :value="filter.unprocessed"
        @input="handleUnprocessed"
      />
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { debounce as _debounce } from "lodash";
import { fetchApplicators } from "../../../repositories/applicators.js";

export default {
  name: "AppProjectFilter",

  data() {
    return {
      datepickerDateFrom: false,
      datepickerDateTo: false,
      applicators: []
    };
  },

  computed: {
    ...mapState({
      filter: state => state.projects.filter
    }),

    applicatorsItems() {
      return this.applicators.map(item => {
        return { id: item.id, fullname: item.fullname.toUpperCase() };
      });
    }
  },

  watch: {
    filter: {
      handler() {
        this.$store.dispatch("projects/fetchProjects");
      },
      deep: true
    }
  },

  methods: {
    handleDateType(date_type) {
      this.$store.commit("projects/SET_DATE_TYPE_FILTER", date_type);
    },

    handleDateFrom(date) {
      this.$store.commit("projects/SET_DATE_FROM_FILTER", date);
    },

    handleDateTo(date) {
      this.$store.commit("projects/SET_DATE_TO_FILTER", date);
    },

    handleApplicator(applicator) {
      this.$store.commit("projects/SET_APPLICATOR_FILTER", applicator);
    },

    handleUnprocessed(value) {
      this.$store.commit("projects/SET_UNPROCESSED_FILTER", value);
    },

    // Use of lodash debounce funtion.
    // Triggers mutation after user stops writing (500ms)
    // Avoid ti trigger mutation on every key press
    handleSearch: _debounce(function(search) {
      if (search.length >= 3) {
        this.$store.commit("projects/SET_SEARCH_FILTER", search);
      }

      if (!search.length) {
        this.$store.commit("projects/SET_SEARCH_FILTER", null);
      }
    }, 500)
  },

  async created() {
    try {
      const { data } = await fetchApplicators();
      this.applicators = data;
    } catch (error) {
      console.log(error);
    }
  }
};
</script>

<style></style>
